import { Domain } from '@pepper/utils/src/types/seo'

import { useSEOCountriesJSON } from 'container/SEOTools/hooks/useSEOCountriesJSON'

import s from './DomainPill.module.css'

type Props = {
  domain: Domain
}

export const DomainPill = ({ domain }: Props) => {
  const { data: countriesJson } = useSEOCountriesJSON()

  const region = domain.region_code
  const url = domain.domain_url
    ?.replace(/(https?:\/\/)?(www\.)?/, '')
    .replace(/\/$/, '')

  return (
    <div className={s.wrapper}>
      <span className={s.url} title={url}>
        {url}
      </span>
      {countriesJson && (
        <img className={s.flag} src={countriesJson[region].flag} alt={region} />
      )}
    </div>
  )
}
